import React, {useCallback, useMemo, useState} from 'react'
import {useTranslation} from 'i18n'
import {useSelector} from 'lib/redux'
import {FirebaseMessageRoomItemPayload, GiftShopContentData} from 'types'
import {requestData} from 'services'
import {Paragraph} from 'common/components'
import {useDidMount, useHistory} from 'utils'
import GiftShopMessageRoomContentList from './GiftShopMessageRoomContentItemList'
import {
  getMessageContentIds,
  getMessagePrice,
  updateMessagePrice,
} from '../GiftshopMessageArrayHelper'

export interface GiftShopMessageRoomContentItemReminderCartProps {
  payload: FirebaseMessageRoomItemPayload['reminder_cart']
}

export default function GiftShopMessageRoomContentItemReminderCart({
  payload: {contents, data: contentData},
}: GiftShopMessageRoomContentItemReminderCartProps) {
  const {translate} = useTranslation()
  const {username} = useSelector('user')!
  const [data, setData] = useState<GiftShopContentData[]>([])
  const [loading, setLoading] = useState(true)
  const history = useHistory()
  const contentIds = getMessageContentIds(contentData, contents)
  const prices = getMessagePrice(contentData)

  const handleLoadData = useCallback(
    () =>
      requestData('giftshop_get_contents_detail', {
        params: {content_ids: contents.toString()},
        onRequestSuccess: ({status, data: {result}}) => {
          result = updateMessagePrice(result, contentIds, prices)
          status === 200 &&
            setData(result.map((item) => ({...item, is_cart: true})))
          setLoading(false)
        },
      }),
    [contentIds, contents, prices],
  )

  const handleRenderMessage = useMemo(
    () => (
      <Paragraph fontSize="m">
        {translate('messages:reminderCart', {
          username,
        })}
      </Paragraph>
    ),
    [username, translate],
  )

  const handleRenderContent = useMemo(
    () => (
      <GiftShopMessageRoomContentList
        data={data}
        onClick={(item) =>
          history.push('giftshop_cart_detail', {
            data: [{...item, is_cart: true, is_wishlist: true}],
            selectedItemId: item.content_id,
          })
        }
        dataCount={contents.length}
        loading={loading}
      />
    ),
    [contents.length, data, history, loading],
  )

  useDidMount(() => {
    handleLoadData()
  })

  return (
    <>
      {handleRenderMessage}
      {handleRenderContent}
    </>
  )
}
